var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h10zM8.476 4.8a.568.568 0 0 0-.485.29L5.86 8.623l-.65-.916a.567.567 0 0 0-.457-.249.564.564 0 0 0-.458.25L2.73 9.92a.734.734 0 0 0-.07.703c.097.23.303.376.528.376h8.227a.58.58 0 0 0 .519-.354.741.741 0 0 0-.035-.684L8.96 5.091a.57.57 0 0 0-.484-.291zM4.1 3a1.3 1.3 0 1 0 0 2.6 1.3 1.3 0 0 0 0-2.6z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureIcon);
export default __webpack_public_path__ + "static/media/picture-icon.729b97cedeb2dfa9025f6e74387fe659.svg";
export { ForwardRef as ReactComponent };